/** Transparent product mockup (French): 6 volumes + tablet, laptop and phone. */
export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/6ZanbL6aovZerqhWa2345Z/Mock_up_MIR_frances.png'

export const TEACHING_INSTRUCTOR_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/d2e60d2a-f837-488a-a9e6-77d6e76fef65.jpg'
